/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { LangServiceConfig } from './interfaces';

export class LangService {

    protected readonly allLangPaths: LangServiceConfig['allLangPaths'];
    protected readonly defaultLocale: string;

    protected loadedLocale: string;
    protected loadedLanguages: Record<string, string>;

    constructor(langServiceConfig: LangServiceConfig) {
        const {
            allLangPaths,
            defaultLocale = 'en',
        } = langServiceConfig;

        this.allLangPaths = allLangPaths;
        this.defaultLocale = defaultLocale;
        this.loadedLocale = null;
        this.loadedLanguages = {};
    }

    getLang(locale: string = this.defaultLocale): Promise<Record<string, string>> {
        if (this.loadedLocale === locale) {
            return Promise.resolve(this.loadedLanguages);
        }

        return this.loadLangFor(locale)
            .then(() => this.loadedLanguages);
    }

    protected loadLangFor(locale: string): Promise<void> {
        return this.allLangPaths[locale]()
            .then((langFileData: Record<string, string>) => {
                this.loadedLanguages = langFileData;
            })
            .catch((err) => {
                err && console.error(err);
                this.loadedLanguages = {};
            });
    }

}
